import axios, { AxiosRequestConfig } from "axios";
import { concatMap, Observable } from "rxjs";
import { Token } from "../model/Token";
import {
  ClientDeviceType,
  createUserAgentString,
  SupportedOS,
  UserAgent,
} from "../model/UserAgent";
import generateSecureToken from "../utils/generateSecureToken";

interface PostParams {
  path: string;
  body?: any;
}

class MetricsService {
  private _endpoint = "https://metrics2.blacknut.com";
  public get endpoint(): string {
    return this._endpoint;
  }
  public set endpoint(v: string) {
    this._endpoint = v;
  }

  private _userToken?: Token;
  public get userToken(): Token | undefined {
    return this._userToken;
  }
  public set userToken(v: Token | undefined) {
    this._userToken = v;
  }

  private _userAgent: UserAgent = {
    apiVersion: "5.0.2",
    client: ClientDeviceType.WEB,
    clientVersion: "1.0.0",
    deviceType: "DESKTOP",
    os: SupportedOS.Windows,
  };
  public get userAgent(): UserAgent {
    return this._userAgent;
  }
  public set userAgent(v: UserAgent) {
    this._userAgent = v;
  }

  private getDefaultAxiosConfig(opts?: { secureToken?: string }): AxiosRequestConfig {
    const res: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${this._userToken?.accessToken}`,
        "X-Blk-User-Agent": createUserAgentString(this.userAgent),
        "X-Blk-Secure-Token": opts?.secureToken || undefined,
      },
      responseType: "json",
    };
    return res;
  }

  public post<T>({ path, body }: PostParams) {
    return generateSecureToken(this._userAgent).pipe(
      concatMap((secureToken) => {
        return new Observable<T>((observer) => {
          axios
            .post<T>(
              `${this.endpoint}/${path}`,
              body,
              this.getDefaultAxiosConfig({ secureToken }),
            )
            .then((res) => {
              observer.next(res.data);
              observer.complete();
            })
            .catch((e) => {
              observer.error(e);
              observer.complete();
            });
        });
      }),
    );
  }
}

const metricsService = new MetricsService();
export default metricsService;
